import { render } from "./MbWrapView.vue?vue&type=template&id=141f8ede&scoped=true"
import script from "./MbWrapView.vue?vue&type=script&lang=js"
export * from "./MbWrapView.vue?vue&type=script&lang=js"

import "./MbWrapView.vue?vue&type=style&index=0&id=141f8ede&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-geoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141f8ede"]])

export default __exports__